<template>
    <div class="authorization">
        <div class="authorization-tabs authorization_tabset tabset">
            <div class="authorization_tabset-controls">
                <div class="authorization_tabset-title-1">
                    <input type="radio" name="tabset" id="tab1" aria-controls="login" :checked="isLogInRoute">
                    <label class="headline-s" for="tab1">Login</label>
                </div>
                <div class="authorization_tabset-title-2">
                    <input type="radio" name="tabset" id="tab2" aria-controls="description" :checked="!isLogInRoute">
                    <label class="headline-s" for="tab2">Create Account</label>
                </div>
            </div>
            <div class="authorization_tabset-panels">
                <section id="login" class="authorization_tabset-panel">
                    <p class="authorization-login_subtitle">Log into your Rothco account for expedited checkout,
                        enhanced product recommendations, and more!
                    </p>
                    <LoginTab />
                </section> 
                <section id="registration" class="authorization_tabset-panel">
                    <p class="authorization-login_subtitle">Create a Rothco account for expedited checkout, enhanced
                        product recommendations, and more! <br />
                        <span>Note: prospective dealers should <Link :href="route('index.becomeADealer')" class="authorization-learn_more_link">learn more & apply here.</Link></span>
                    </p>
                    <CreateAccountTab />
                </section>
                </div>
            </div>
            <div class="authorization-banner">
            <img src="@images/men_traveling_auth.png" class="authorization-banner_image" />
            <div class="authorization-banner_description">
                <h2 class="headline-xs authorization-banner_title">Join Our Dealer Network</h2>
                <p class="paragraph-details authorization-banner_subtitle">Join our extensive network of Rothco dealers
                    worldwide</p>
                <div class="authorization-banner_points">
                    <p class="paragraph-details"><span>95%</span> of orders ship within 24hrs</p>
                    <p class="paragraph-details"><span>99%</span> in-stock rate</p>
                    <p class="paragraph-details"><span>4,000+</span> exclusive rothco products</p>
                </div>
                <RothcoCta class="secondary" :href="route('index.becomeADealer')">Learn More & Apply</RothcoCta>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
    import LoginTab from "@/components/auth/LoginTab.vue";
    import CreateAccountTab from "@/components/auth/CreateAccountTab.vue";
    import RothcoCta from "@/components/RothcoCta.vue";
    import { computed, inject } from "vue";
    import { Link, usePage } from "@inertiajs/vue3";

    const isLogInRoute = computed(() => {
        return usePage().url.includes('login');
    });

</script>
